import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import Divider from '@mui/material/Divider';

import * as basicConstants from '../../constants/basic';
import * as urlConstants from '../../constants/url';
import { LinkInternalNormal } from '../customComponent/link';
import { ArticleOutlinedIcon, AccountTreeOutlinedIcon } from '../../constants/images';
import useGlobalStatus from '../../hook/useGlobalStatus';
import { MEDIA_DATA, currentMediaType } from '../../constants/mediaData';
import theme from '../../theme';


const Nav = (props) => {
  const location = useLocation();
  const { userData } = props;
  const [open, setOpen] = useState(true);
  const { setCurrentActiveData, setEntryPath } = useGlobalStatus();

  const handleClick = () => {
    setOpen(!open);
  };

  return (
    <>
      <List
        sx={{
          width: '100%',
          minWidth: '22%',
          bgcolor: 'background.paper',
          mt: '5px',
        }}
        component="nav"
        aria-labelledby="nested-list-subheader"
      >
        {
          userData && userData.scopes.includes(basicConstants.AUTH_EDIT_REPORT) &&
          <>
            <ListItem
              sx={{
                width: 'auto',
                padding: '10px 20px',
                margin: { xs: '8px 0', md: '0' },
                cursor: 'pointer'
              }}
              onClick={handleClick}
            >
              <ArticleOutlinedIcon />
              <ListItemText primary={<FormattedMessage id="common.title.reportManagement" />} sx={{ ml: '12px' }} />
              {open ? <ExpandLess /> : <ExpandMore />}
            </ListItem>

            <Collapse in={open} timeout="auto" unmountOnExit>
              {currentMediaType.map((el, index) => {
                return (
                  <List component="div" disablePadding key={`${index}_${MEDIA_DATA[el].media}`}>
                    <LinkInternalNormal
                      mediacolor={MEDIA_DATA[el].color}
                      className={`
                    nav-list
                    ${' link--normal link--align--center'}
                    ${location.pathname.includes(MEDIA_DATA[el].sendListUrl) && ' active'}
                    ${location.pathname.includes(MEDIA_DATA[el].createDataUrl) && ' active'}   
                    `}
                      to={MEDIA_DATA[el].sendListUrl}
                      onClick={() => {
                        props.toggleDrawer();
                        setCurrentActiveData(false);
                        setEntryPath(MEDIA_DATA[el].entryPath);
                      }}
                    >
                      <ListItemText primary={MEDIA_DATA[el].media} sx={{ pl: '42px' }} />
                    </LinkInternalNormal>
                  </List>
                )
              })}
            </Collapse>
          </>
        }

        <Divider sx={{ margin: '10px 0' }} />

        {userData && userData.scopes.includes(basicConstants.AUTH_BIND_AD_ACCOUNTS) &&
          <ListItem
            sx={{
              width: 'auto',
              margin: { mb: '0', xs: '8px 0' },
              padding: '0 0 0 8px'
            }}
          >
            <LinkInternalNormal
              mediacolor={theme.palette.system.main}
              className={`
                nav-list
                ${' link--normal link--align--center'}
                ${location.pathname.includes(urlConstants.PAGE_AD_ACCOUNTS) && ' active'}
            `}
              to={urlConstants.PAGE_AD_ACCOUNTS}
              onClick={() => {
                props.toggleDrawer();
                setEntryPath(basicConstants.HAIREPORT);
              }}
            >
              <AccountTreeOutlinedIcon />
              <ListItemText primary={<FormattedMessage id="common.title.accountManagement" />} sx={{ ml: '12px' }} />
            </LinkInternalNormal>
          </ListItem>}
      </List>
    </>
  )
}

export default Nav;